import { OFFER_SOURCE_OF_FUNDS_INDIA } from 'constants/fields';
import { getFieldValue } from 'selectors/ui/ui';
import type { PayexThunkAction } from 'store/configureStore';
import { trackEvent } from './tracker';

const trackSelectSourceOfFundsIndia =
  (selectedSourceOfFunds: string): PayexThunkAction =>
  (_dispatch, _getState, { tracker }) => {
    const category = 'payment action';
    const action = 'click';
    const name = 'click_select_source_of_funds_india';
    const value = 'click_select_source_of_funds_india';
    const props = {
      action,
      category,
      value,
      sourceOfFunds: selectedSourceOfFunds,
    };

    return trackEvent(tracker, name, props);
  };

const trackClickPreviousSourceOfFunds =
  (step: string): PayexThunkAction =>
  (_dispatch, getState, { tracker }) => {
    let stepName = step;

    if (step === 'sourceOfFunds') {
      const state = getState();
      const selectedSourceOfFunds = getFieldValue(
        state,
        OFFER_SOURCE_OF_FUNDS_INDIA,
      );

      if (selectedSourceOfFunds) {
        stepName = 'financialInstitution';
      }
    }

    const name = 'click_previous_source_of_funds';
    const category = 'payment action';
    const action = 'click';
    const value = 'click_previous_source_of_funds';
    const props = {
      action,
      category,
      value,
      step: stepName,
    };

    return trackEvent(tracker, name, props);
  };

const trackSelectFinancialInstitutionIndia =
  (selectedFinancialInstitution: string): PayexThunkAction =>
  (_dispatch, _getState, { tracker }) => {
    const name = 'click_select_bank_financial_institution';
    const category = 'payment action';
    const action = 'click';
    const value = 'click_select_bank_financial_institution';
    const props = {
      action,
      category,
      value,
      financialInstitution: selectedFinancialInstitution,
    };

    return trackEvent(tracker, name, props);
  };

export {
  trackSelectSourceOfFundsIndia,
  trackClickPreviousSourceOfFunds,
  trackSelectFinancialInstitutionIndia,
};
